/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import React, { useContext } from 'react';
import { DialogActions, Button } from '@mui/material';

import { ElasticDslEntitlementContext } from './ElasticDslEntitlementContext';

interface IElasticDslDialogActionsProps {
  onClose: () => void;
  disabled: boolean;
}

export const ElasticDslDialogActions = ({ onClose, disabled }: IElasticDslDialogActionsProps) => {
  const { onAdd } = useContext(ElasticDslEntitlementContext);

  return (
    <DialogActions>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          onAdd();
          onClose();
        }}
        disabled={disabled}
      >
        Add
      </Button>
    </DialogActions>
  );
};
